import { observer } from 'mobx-react-lite';
import { LoanApplicationDto } from 'src/generated-api-client';
import { LoanApplicationFinalOffer } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationFinalOffer';
import { LoanApplicationGeneralInfo } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationGeneralInfo';
import { LoanApplicationInitialOffer } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationInitialOffer';
import { LoanApplicationPartnerInfo } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationPartnerInfo';

type LoanApplicationGeneralInfoTabProps = {
    application?: LoanApplicationDto;
};

export const LoanApplicationGeneralInfoTab = observer(
    ({ application }: LoanApplicationGeneralInfoTabProps) => {
        return (
            <>
                <LoanApplicationGeneralInfo application={application} />
                <LoanApplicationPartnerInfo application={application} />
                <LoanApplicationInitialOffer application={application} />
                <LoanApplicationFinalOffer application={application} />
            </>
        );
    },
);
